import { StyleSheet } from 'react-native';

import { Theme } from '@constants';

export const styles = StyleSheet.create({
  pipPlaceholderImage: {
    borderRadius: Theme.px(6),
    opacity: 1,
  },
  pipWrapper: {
    elevation: 500,
    padding: Theme.px(12),
    position: 'absolute',
    zIndex: 500,
  },
  radialGradientBackgroundContainer: {
    height: '100%',
  },
});
